import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    clearPersonalCyberFormData,
    selectPersonalCyberForm,
    setPersonalCyberFormData
} from "../redux/features/personalCyberFormSlice";

const usePersonalCyberForm = (formName, setFormData) => {
    const dispatch = useDispatch();
    const personalCyberFormData = useSelector(selectPersonalCyberForm);
    const redux_form_data = personalCyberFormData?.[formName];
    const isInitialized = useRef(false);

    useEffect(() => {
        // Only initialize once per mount
        if (isInitialized.current) return;

        if (redux_form_data) {
            setFormData(redux_form_data);
            isInitialized.current = true;
        }
    }, [redux_form_data, setFormData]);

    const savePersonalCyberDataInRedux = async (formData) => {
        return new Promise((resolve, reject) => {
            try {
                dispatch(setPersonalCyberFormData({ form_name: formName, data: formData }));
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };

    const removePersonalCyberFormData = () => {
        dispatch(clearPersonalCyberFormData({ form_name: formName }));
    };

    return { 
        savePersonalCyberDataInRedux, 
        removePersonalCyberFormData, 
        redux_form_data 
    };
};

export default usePersonalCyberForm;